import React from 'react';
import styled from 'styled-components';
import { DoubleCircledIcon } from 'styleguide/CircledIcons';
import { Spacing } from 'styleguide/spacing';
import { P2 } from 'styleguide/Texts';
import { t } from 'translations/t';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${Spacing.md}px;
  min-height: 200px;
`;

export const EmptyGraph = ({ title }: { title?: string }) => {
  return (
    <Container>
      <DoubleCircledIcon type="bar-chart"></DoubleCircledIcon>
      <P2 style={{ textAlign: 'center', marginTop: Spacing.md, marginBottom: Spacing.md }}>
        {title || t('web.profile.emptyGraph.noData')}
      </P2>
    </Container>
  );
};
